document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap === "undefined") {
    // eslint-disable-next-line no-console
    console.warn("GSAP not loaded");
    return;
  }

  const scrollTriggerAvailable =
    typeof ScrollTriggerUtils !== "undefined" && ScrollTriggerUtils.register();

  const heroSection = document.querySelector(".hero-section");
  if (!heroSection) {
    return;
  }

  const mainIcons = document.querySelectorAll(".hero-icons .floating-icon");
  const heroIconsBg = document.querySelector(".hero-icons-bg");
  const backgroundIcons = document.querySelectorAll(
    ".hero-icons-bg .floating-icon"
  );

  // Foreground icons
  if (mainIcons.length > 0) {
    mainIcons.forEach((icon) => {
      gsap.set(icon, {
        transformOrigin: "center center",
        scale: 0.8,
        opacity: 0,
      });

      gsap.to(icon, {
        opacity: 1,
        scale: 1,
        duration: 2,
        ease: "back.out(1.2)",
        delay: Math.random() * 0.4,
        force3D: true,
      });
    });
  }

  // Scroll parallax for foreground icons
  if (scrollTriggerAvailable && mainIcons.length > 0) {
    mainIcons.forEach((icon, index) => {
      const speeds = [0.2, 0.3, 0.4, 0.4, 0.3, 0.2];
      const speed = speeds[index % speeds.length];

      gsap.to(icon, {
        y: -300 * speed,
        ease: "none",
        scrollTrigger: {
          trigger: heroSection,
          start: "top top",
          end: "bottom top",
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });
    });
  }

  // Background icons
  if (heroIconsBg && backgroundIcons.length > 0) {
    gsap.to(heroIconsBg, {
      opacity: 1,
      duration: 1.5,
      ease: "power2.out",
      delay: 0.3,
    });

    if (scrollTriggerAvailable) {
      backgroundIcons.forEach((icon, index) => {
        const backgroundSpeeds = [0.1, 0.15, 0.12, 0.18, 0.13, 0.16];
        const speed = backgroundSpeeds[index % backgroundSpeeds.length];

        gsap.to(icon, {
          y: -200 * speed,
          ease: "none",
          scrollTrigger: {
            trigger: heroSection,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            invalidateOnRefresh: true,
          },
        });
      });
    }
  }

  // Logos entrance
  const logoItems = document.querySelectorAll(".logos-wrapper .logo-item");
  if (logoItems.length > 0) {
    gsap.to(logoItems, {
      opacity: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.out",
      stagger: 0.1,
      delay: 0,
    });
  }
});
